import { parseCap } from '@herald/core';

/**
 * Czech presentation of protocol values.
 *
 * `@herald/core` is language-agnostic on purpose -- it is a protocol library,
 * and `formatCap()` there returns English. Rendering that straight into a Czech
 * UI put "max 2 messages / 30 days" in the middle of the consent screen, which
 * is the one screen a user is asked to read carefully. Presentation belongs to
 * the interface, so it lives here.
 */

/** Czech has three plural forms: 1, 2-4, and 5+. */
function plural(n, one, few, many) {
  if (n === 1) return one;
  if (n >= 2 && n <= 4) return few;
  return many;
}

const messages = (n) => `${n} ${plural(n, 'zpráva', 'zprávy', 'zpráv')}`;
const days = (n) => `${n} ${plural(n, 'den', 'dny', 'dní')}`;
const hours = (n) => `${n} ${plural(n, 'hodinu', 'hodiny', 'hodin')}`;

/**
 * @param {string|null} cap a frequency cap such as "4/30d"
 * @returns {string} e.g. "nejvýše 4 zprávy za 30 dní"
 */
export function formatCapCs(cap) {
  let parsed;
  try {
    parsed = parseCap(cap);
  } catch {
    // An unparseable cap is a sender's problem, but the reader still needs a
    // truthful label rather than a crash or a silent "no limit".
    return 'limit v nerozpoznaném formátu';
  }
  if (!parsed) return 'bez deklarovaného limitu';

  const window = parsed.windowSeconds % 86400 === 0
    ? days(parsed.windowSeconds / 86400)
    : hours(Math.round(parsed.windowSeconds / 3600));
  return `nejvýše ${messages(parsed.count)} za ${window}`;
}

/** Retention, for the same reason. */
export function formatRetentionCs(retentionDays) {
  const value = Number(retentionDays);
  if (!Number.isFinite(value) || value <= 0) return 'bez omezení';
  return days(value);
}
